import { Link } from "react-router-dom";

export default function RelatedArticlesSidebar({ articles = [] }) {
    return (
        <aside className="hidden lg:block">
            <div className="sticky top-24">
                <div className="bg-white rounded-xl overflow-hidden border border-indigo-300 shadow-sm">

                    {/* HEADER */}
                    <div className="bg-purple-600 text-white px-5 py-3 flex items-center gap-2">
                        <span className="text-lg">🔗</span>
                        <h3 className="text-lg font-semibold tracking-wide">
                            Related Articles
                        </h3>
                    </div>

                    {/* LIST */}
                    <div className="p-4 space-y-4">
                        {articles.length === 0 ? (
                            <p className="text-gray-500 text-sm text-center">
                                No related articles
                            </p>
                        ) : (
                            articles.map((article) => (
                                <Link
                                    to={`/article/${article.slug}`}
                                    key={article.slug}
                                    className="flex gap-3 items-start group"
                                >
                                    {/* THUMBNAIL */}
                                    <img
                                        src={article.images || "/placeholder.jpg"}
                                        alt={article.title}
                                        onError={(e) => (e.target.src = "/placeholder.jpg")}
                                        className="
                      w-24 h-16
                      rounded-md
                      object-cover
                      flex-shrink-0
                      border
                    "
                                    />

                                    {/* CONTENT */}
                                    <div className="flex-1">
                                        <p
                                            className="
                        text-sm font-semibold leading-snug
                        text-gray-900
                        group-hover:text-indigo-600
                        transition
                        line-clamp-2
                      "
                                        >
                                            {article.title}
                                        </p>

                                        {/* META */}
                                        <div className="mt-1 flex items-center gap-1 text-xs text-gray-500">
                                            <span>👁</span>
                                            <span className="font-medium">
                                                {article.views || 0}
                                            </span>
                                        </div>
                                    </div>
                                </Link>
                            ))
                        )}
                    </div>

                </div>
            </div>
        </aside>
    );
}
